import React from 'react';

export const sprintPhases = {
    "Map": [
      {
        title: "Prototype Personas",
        icon: "🧑",
        phase: "Stap 1: Map",
        example: "Maak gedetailleerde gebruikerprofielen",
        hboi: {
          activities: ["Analyseren"]
        }
      },
      {
        title: "Journey Map",
        icon: "🗺️",
        phase: "Stap 1: Map",
        example: "Breng kritieke gebruikersmomenten in kaart",
        hboi: {
          activities: ["Analyseren", "Adviseren"]
        }
      }
    ],
    "Sketch": [
      {
        title: "Crazy 8's",
        icon: "✏️",
        phase: "Stap 2: Sketch",
        example: "Genereer 8 ideeën in 8 minuten",
        hboi: {
          activities: ["Ontwerpen"]
        }
      }
    ],
    "Decide": [
      {
        title: "Impact/Effort Matrix",
        icon: "📊",
        phase: "Stap 3: Decide",
        example: "Prioriteer ideeën op impact en moeite",
        hboi: {
          activities: ["Adviseren"]
        }
      }
    ],
    "Prototype": [
      {
        title: "Storyboard & Prototype",
        icon: "🎨",
        phase: "Stap 4: Prototype",
        example: "Bouw klikbaar prototype",
        hboi: {
          activities: ["Ontwerpen", "Realiseren"]
        }
      }
    ],
    "Test": [
      {
        title: "Gebruikerstest",
        icon: "🧪",
        phase: "Stap 5: Test",
        example: "Test prototype met 5 gebruikers",
        hboi: {
          activities: ["Realiseren"]
        }
      }
    ]
  };
  
 
export const sectionData = [
    {
        key: "voorbereiding",
        title: "🧑‍🧑‍🧒‍🧒 Probleemdefinitie",
        steps: [
          {
            title: "Probleemverkenning",
            icon: "⚡️",
            phase: "Stap 1",
            example:
              "Verfijn probleem via projectvoorstel, competitor review, user en stakeholder interviews",
            description: (
              <div className="space-y-8">
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-3xl font-bold text-gray-800">
                        Probleemverkenning
                      </h1>
                      <p className="text-lg text-gray-700">
                        Begin met het helder krijgen van het probleem dat je wilt
                        oplossen. Een goed gedefinieerd probleem is essentieel
                        voor het succes van je project en helpt je team gefocust
                        te blijven op de juiste oplossing.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Stel deze vragen:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Voor wie los je iets op?</li>
                          <li>Wat is hun probleem?</li>
                          <li>Wanneer hebben ze er last van?</li>
                          <li>Waarom is het belangrijk?</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/problem.jpg"
                        alt="Problem exploration voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Onderzoek Context</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Review projectvoorstel</li>
                      <li>Analyseer stakeholders</li>
                      <li>Check concurrentie</li>
                      <li>Verzamel data</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Probleem Statement</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Gebruik het format</li>
                      <li>Wees specifiek</li>
                      <li>Focus op impact</li>
                      <li>Vermijd oplossingen</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Validatie</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Check met stakeholders</li>
                      <li>Test met '5 Whys'</li>
                      <li>Verifieer urgentie</li>
                      <li>Documenteer inzichten</li>
                    </ul>
                  </div>
                </div>
  
                {/* Problem Statement Format */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">
                    Probleem Statement Format
                  </h3>
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <p className="italic">
                      "[Gebruiker] heeft probleem met [probleem] tijdens [context]
                      omdat [reden]"
                    </p>
                  </div>
                  <div className="mt-4 bg-green-50 p-4 rounded-lg">
                    <h4 className="font-bold mb-2">Voorbeeld:</h4>
                    <p className="italic">
                      "Studenten hebben moeite met het organiseren van
                      studentenfeesten omdat alle informatie en taken nu verspreid
                      zijn over verschillende apps en groepschats"
                    </p>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    1-2 hours
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor een goed probleem statement",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">
                    Tips voor een goed probleem statement:
                  </h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Hou het simpel en duidelijk</li>
                    <li>Focus op de gebruiker</li>
                    <li>Maak het meetbaar</li>
                    <li>Vermijd oplossingen</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Gebruik de '5 Whys'-methode om tot de kern te komen</li>
                    <li>
                      Houd het SMART: Specifiek, Meetbaar, Acceptabel,
                      Realistisch, Tijdsgebonden
                    </li>
                    <li>
                      Test je statement met de 'Grandma Test' - zou je oma het
                      begrijpen?
                    </li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.designkit.org/methods/frame-your-design-challenge.html"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Frame Your Design Challenge (IDEO Design Kit)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/problem-statements/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Writing Problem Statements (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.interaction-design.org/literature/article/define-and-frame-your-design-challenge-by-creating-your-point-of-view-and-ask-how-might-we"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Define and Frame Your Design Challenge (IDF)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Is het probleem specifiek genoeg geformuleerd?</li>
                    <li>Heb je de doelgroep duidelijk afgebakend?</li>
                    <li>Kan je het probleem kwantificeren met data?</li>
                    <li>Hebben stakeholders het probleem bevestigd?</li>
                    <li>Is het probleem urgent genoeg om nu op te lossen?</li>
                    <li>
                      Welke wet- en regelgeving is in deze context van toepassing?
                    </li>
                    <li>
                      Zijn er ethische vraagstukken gemoeid met deze
                      probleemstelling, denk aan de SDGs?
                    </li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Format:</h4>
                  <p className="italic">
                    [Gebruiker] heeft probleem met [probleem] tijdens [context]
                    omdat [reden]
                  </p>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Voorbeeld:</h4>
                  <p className="italic">
                    "Studenten hebben moeite met het organiseren van
                    studentenfeesten omdat alle informatie en taken nu verspreid
                    zijn over verschillende apps en groepschats"
                  </p>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Analyseren"],
            },
          },
          {
            title: "Aannames Verzamelen",
            icon: "💭",
            phase: "Stap 2",
            example: "Brainstorm ideeën voor gevonden risico's",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Aannames Verzamelen
                      </h1>
                      <p className="text-lg text-gray-700">
                        Maak alle aannames expliciet die impact kunnen hebben op
                        je project. Door aannames vroeg te identificeren, kun je
                        gerichter testen en risico's minimaliseren.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Soorten aannames:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Gebruiker aannames (geel)</li>
                          <li>Business aannames (blauw)</li>
                          <li>Technische aannames (groen)</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/assumptions.png"
                        alt="Assumptions collection voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Individueel Brainstormen</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Schrijf alle aannames op</li>
                      <li>Gebruik verschillende kleuren</li>
                      <li>Focus op één type per ronde</li>
                      <li>Wees specifiek en meetbaar</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Groeperen & Delen</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Deel met het team</li>
                      <li>Cluster vergelijkbare aannames</li>
                      <li>Identificeer patronen</li>
                      <li>Vul blinde vlekken aan</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Validatie Planning</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Bepaal testmethode</li>
                      <li>Stel succescriteria op</li>
                      <li>Plan validatiemomenten</li>
                      <li>Documenteer resultaten</li>
                    </ul>
                  </div>
                </div>
  
                {/* Example Assumptions */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">
                    Voorbeelden per Categorie
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">👤 Gebruiker Aannames</h4>
                      <ul className="list-disc ml-4 space-y-2">
                        <li>
                          "Studenten willen push notificaties voor feesten in de
                          buurt"
                        </li>
                        <li>"Gebruikers checken dagelijks nieuwe events"</li>
                        <li>"Privacy is een hoofdzorg voor gebruikers"</li>
                      </ul>
                    </div>
  
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">💼 Business Aannames</h4>
                      <ul className="list-disc ml-4 space-y-2">
                        <li>
                          "Verenigingen willen betalen voor premium features"
                        </li>
                        <li>"Advertenties zijn een viable inkomstenbron"</li>
                        <li>"Partnerships met venues zijn mogelijk"</li>
                      </ul>
                    </div>
  
                    <div className="bg-green-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">⚙️ Technische Aannames</h4>
                      <ul className="list-disc ml-4 space-y-2">
                        <li>"We kunnen dit in 3 sprints bouwen"</li>
                        <li>"Real-time updates zijn noodzakelijk"</li>
                        <li>"API integraties zijn beschikbaar"</li>
                      </ul>
                    </div>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    45-60 mins
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor aannames verzamelen",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">
                    Tips voor aannames verzamelen:
                  </h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Schrijf eerst individueel</li>
                    <li>Wees specifiek en meetbaar</li>
                    <li>Denk aan verschillende stakeholders</li>
                    <li>Vraag door met 'waarom'</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Gebruik de 'Worst Idea'-methode om creativiteit te
                      stimuleren: vraag eerst naar slechte ideeën, draai ze daarna
                      om tot goede oplossingen
                    </li>
                    <li>
                      Maak gebruik van 'Time Boxing': zet een timer voor elke
                      brainstormfase om focus te behouden
                    </li>
                    <li>
                      Combineer individueel werk met groepssessies om groepsdenken
                      te voorkomen
                    </li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/tracking-questions-assumptions-facts-agile/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Tracking Research Questions, Assumptions, and Facts in
                        Agile (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.nngroup.com/videos/tracking-assumptions/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Assumption Tracking for UX Projects (Nielsen Norman Group)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Zijn de aannames specifiek en testbaar?</li>
                    <li>
                      Heb je aannames uit verschillende perspectieven (gebruiker,
                      business, technisch)?
                    </li>
                    <li>
                      Zijn de aannames gebaseerd op observaties of vermoedens?
                    </li>
                    <li>Welke aannames zijn het meest risicovol?</li>
                    <li>Heb je blind spots in je aannames?</li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">👤 Gebruiker Aannames:</h4>
                  <p className="italic">
                    "Studenten willen push notificaties voor feesten in de buurt"
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">💼 Business Aannames:</h4>
                  <p className="italic">
                    "Verenigingen willen betalen voor premium features"
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">⚙️ Technische Aannames:</h4>
                  <p className="italic">"We kunnen dit in 3 sprints bouwen"</p>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Analyseren"],
            },
          },
          {
            title: "Aannames Mapping",
            icon: "🗺️",
            phase: "Stap 3",
            example: "Prioriteer welke risico's eerst aan te pakken",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Aannames Mapping
                      </h1>
                      <p className="text-lg text-gray-700">
                        Orden je aannames op basis van risico en zekerheid om te
                        bepalen waar je moet beginnen. Deze methode helpt je team
                        om gefocust te blijven op de belangrijkste onzekerheden in
                        je project.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          De Matrix Kwadranten:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Hoog Risico, Bekend = Direct Doen</li>
                          <li>Hoog Risico, Onbekend = Onderzoeken</li>
                          <li>Laag Risico, Bekend = Later</li>
                          <li>Laag Risico, Onbekend = Monitor</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/assumptions-mapping.jpg"
                        alt="Assumption Mapping voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Verzamel & Categoriseer</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Gebruik verschillende kleuren</li>
                      <li>Schrijf één aanname per post-it</li>
                      <li>Label per type aanname</li>
                      <li>Wees specifiek en meetbaar</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Plot & Prioriteer</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Bepaal risico niveau</li>
                      <li>Schat zekerheid in</li>
                      <li>Plaats in matrix</li>
                      <li>Discussieer met team</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Plan Acties</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Bepaal test methode</li>
                      <li>Definieer succescriteria</li>
                      <li>Stel tijdlijn op</li>
                      <li>Verdeel verantwoordelijkheden</li>
                    </ul>
                  </div>
                </div>
  
                {/* Matrix Example */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">
                    Risico/Zekerheid Matrix
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-red-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">
                        Hoog Risico / Lage Zekerheid
                      </h4>
                      <ul className="list-disc ml-4">
                        <li>"Gebruikers willen betalen voor premium features"</li>
                        <li>"AI matching verbetert gebruikerservaring"</li>
                      </ul>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">
                        Hoog Risico / Hoge Zekerheid
                      </h4>
                      <ul className="list-disc ml-4">
                        <li>"Huidige planningsapps voldoen niet"</li>
                        <li>"Privacy is hoofdzorg voor gebruikers"</li>
                      </ul>
                    </div>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    45-60 mins
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor mapping",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Tips voor mapping:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Begin met hoog-risico items</li>
                    <li>Kijk naar impact vs effort</li>
                    <li>Denk aan afhankelijkheden</li>
                    <li>Plan concrete acties</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Gebruik een digitale tool zoals Miro voor remote teams
                    </li>
                    <li>Implementeer een 'confidence score' voor elke aanname</li>
                    <li>Herzie de map regelmatig tijdens het project</li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.strategyzer.com/library/how-assumptions-mapping-can-focus-your-teams-on-running-experiments-that-matter"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Testing Business Assumptions (Strategyzer)
                      </a>
                    </li>
  
                    <li>
                      <a
                        href="https://blog.uxtweak.com/assumption-mapping/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Complete Guide to Assumption Mapping (UXtweak)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Zijn de aannames correct geprioriteerd op risico en
                      zekerheid?
                    </li>
                    <li>Zijn er aannames die we over het hoofd hebben gezien?</li>
                    <li>Welke aannames kunnen we direct testen?</li>
                    <li>
                      Zijn de categorieën (gebruikers, business, technisch) goed
                      verdeeld?
                    </li>
                    <li>Hoe realistisch zijn de acties die we hebben gepland?</li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-4 text-lg">De Risico Matrix</h4>
                  <div className="grid grid-cols-4 gap-4 h-[500px]">
                    {/* Y-axis Label */}
                    <div className="flex items-center justify-center -ml-2">
                      <div
                        className="text-sm font-medium whitespace-nowrap"
                        style={{
                          writingMode: "vertical-rl",
                          transform: "rotate(180deg)",
                        }}
                      >
                        ← Laag Risico — Hoog Risico →
                      </div>
                    </div>
  
                    {/* Grid Cells */}
                    <div className="col-span-2 grid grid-cols-2 gap-4 h-full">
                      {/* Top Row */}
                      <div className="bg-red-50 p-4 rounded-lg relative">
                        <div className="absolute top-2 right-2 text-xs text-red-700">
                          Hoog Risico / Lage Zekerheid
                        </div>
                        <div className="mt-8 space-y-2">
                          <div className="bg-yellow-100 p-3 rounded-lg shadow-md rotate-1 transform hover:rotate-0 transition-transform">
                            "Studenten willen push notificaties"
                          </div>
                          <div className="bg-blue-100 p-3 rounded-lg shadow-md -rotate-1 transform hover:rotate-0 transition-transform">
                            "Verenigingen betalen voor premium"
                          </div>
                        </div>
                      </div>
  
                      <div className="bg-yellow-100 p-4 rounded-lg relative">
                        <div className="absolute top-2 left-2 text-xs text-yellow-800">
                          Hoog Risico / Hoge Zekerheid
                        </div>
                        <div className="mt-8 space-y-2">
                          <div className="bg-green-100 p-3 rounded-lg shadow-md -rotate-2 transform hover:rotate-0 transition-transform">
                            "AI matching verbetert matches met 40%"
                          </div>
                        </div>
                      </div>
  
                      {/* Bottom Row */}
                      <div className="bg-gray-100 p-4 rounded-lg relative">
                        <div className="absolute bottom-2 left-2 text-xs text-gray-700">
                          Laag Risico / Lage Zekerheid
                        </div>
                        <div className="space-y-2">
                          <div className="bg-purple-100 p-3 rounded-lg shadow-md rotate-1 transform hover:rotate-0 transition-transform">
                            "NFT tickets mogelijk maken"
                          </div>
                        </div>
                      </div>
  
                      <div className="bg-green-50 p-4 rounded-lg relative">
                        <div className="absolute bottom-2 right-2 text-xs text-green-700">
                          Laag Risico / Hoge Zekerheid
                        </div>
                        <div className="space-y-2">
                          <div className="bg-yellow-100 p-3 rounded-lg shadow-md -rotate-2 transform hover:rotate-0 transition-transform">
                            "Dark mode is nice-to-have"
                          </div>
                        </div>
                      </div>
                    </div>
  
                    {/* Spacer Column */}
                    <div className="flex items-center justify-center">
                      <div className="w-px bg-gray-200 h-full"></div>
                    </div>
  
                    {/* X-axis Label */}
                    <div className="col-span-4 text-center mt-4">
                      <div className="text-sm font-medium">
                        ← Lage Zekerheid — Hoge Zekerheid →
                      </div>
                    </div>
                  </div>
  
                  {/* Legend */}
                  <div className="mt-6 flex flex-wrap gap-4 justify-center">
                    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-full shadow-sm">
                      <div className="w-4 h-4 bg-yellow-100 rounded-sm"></div>
                      <span className="text-xs">Gebruikersaannames</span>
                    </div>
                    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-full shadow-sm">
                      <div className="w-4 h-4 bg-blue-100 rounded-sm"></div>
                      <span className="text-xs">Businessaannames</span>
                    </div>
                    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-full shadow-sm">
                      <div className="w-4 h-4 bg-green-100 rounded-sm"></div>
                      <span className="text-xs">Technische aannames</span>
                    </div>
                  </div>
                </div>
  
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Workshop Tips</h4>
                  <ul className="list-disc ml-4 space-y-2">
                    <li>Begin met 15-20 aannames op post-its per persoon</li>
                    <li>Gebruik verschillende kleuren per categorie</li>
                    <li>Discussieer maximaal 2 minuten per aanname</li>
                    <li>Prioriteer met stemstickers</li>
                  </ul>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Analyseren"],
            },
          },
          {
            title: "Hypothese Statement",
            icon: "🧪",
            phase: "Stap 4",
            example:
              "Kies welke hypothese je gaat testen door middel van een design maken",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Hypothese Statement
                      </h1>
                      <p className="text-lg text-gray-700">
                        Vertaal je belangrijkste aannames naar een testbare
                        hypothese die je kunt valideren in je Design Sprint. Dit
                        vormt de brug tussen je probleemanalyse en je ontwerpfase.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Een goede hypothese:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Is gebaseerd op risicovolle aannames</li>
                          <li>Heeft meetbare succescriteria</li>
                          <li>Is testbaar in Design Sprint</li>
                          <li>Geeft ontwerprichting</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/hu-design-sprint/hu-design-sprint//images/hypothesis-problem.png"
                        alt="Hypothesis Statement voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Probleem Focus</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Kies risicovolste aanname</li>
                      <li>Beschrijf gebruikersprobleem</li>
                      <li>Identificeer pijnpunt</li>
                      <li>Maak het specifiek</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Oplossingsrichting</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Formuleer mogelijke oplossing</li>
                      <li>Blijf conceptueel</li>
                      <li>Link aan Design Sprint</li>
                      <li>Schets eerste ideeën</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Succes Definitie</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Bepaal meetbare criteria</li>
                      <li>Stel target metrics</li>
                      <li>Plan testmethode</li>
                      <li>Definieer tijdspad</li>
                    </ul>
                  </div>
                </div>
  
                {/* Hypothesis Format */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">
                    Van Aanname naar Design Sprint
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">Hypothese Format</h4>
                      <div className="space-y-2">
                        <p>
                          <strong>Gebruikersprobleem:</strong> [Observatie van
                          pijnpunt]
                        </p>
                        <p>
                          <strong>We denken dat:</strong> [Onderliggende
                          behoefte/oorzaak]
                        </p>
                        <p>
                          <strong>Dit testen we door:</strong> [Oplossingsrichting
                          voor Design Sprint]
                        </p>
                        <p>
                          <strong>Succescriterium:</strong> [Meetbaar doel voor
                          prototype test]
                        </p>
                      </div>
                    </div>
  
                    <div className="bg-green-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">
                        Voorbeeld voor Design Sprint
                      </h4>
                      <div className="space-y-2">
                        <p>
                          <strong>Gebruikersprobleem:</strong> "Studenten besteden
                          30+ minuten aan het vinden van relevante feesten"
                        </p>
                        <p>
                          <strong>We denken dat:</strong> Gebruikers behoefte
                          hebben aan betere filter- en zoekfunctionaliteit
                        </p>
                        <p>
                          <strong>Dit testen we door:</strong> Verschillende
                          zoekinterface concepten te verkennen in onze Design
                          Sprint
                        </p>
                        <p>
                          <strong>Succescriterium:</strong> 70% vindt binnen 5
                          minuten 3 relevante feesten tijdens prototype test
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    30-45 mins
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor hypotheses",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Tips voor hypotheses:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Focus op risicovolle aannames</li>
                    <li>Maak het meetbaar</li>
                    <li>Bepaal succescriteria</li>
                    <li>Link aan Design Sprint activiteiten</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Gebruik de 'If...Then...Because' format voor heldere
                      hypotheses
                    </li>
                    <li>
                      Prioriteer hypotheses op basis van potentiële impact en
                      testbaarheid
                    </li>
                    <li>
                      Betrek stakeholders bij het formuleren van hypotheses voor
                      buy-in
                    </li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://designsprintkit.withgoogle.com/resources/method-recipes/pick-the-right-challenges-to-focus-on"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Finding the Right Challenge (Google Ventures Sprint)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/problem-statements/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Writing Problem Statements (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.atlassian.com/team-playbook/plays/problem-framing#:~:text=Using%20the%20ideas%20generated%20by,where%20the%20problem%20is%20happening."
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Creating Effective Problem Statements (Atlassian)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Is de hypothese duidelijk en meetbaar geformuleerd?</li>
                    <li>Sluit de hypothese aan bij de belangrijkste aannames?</li>
                    <li>Zijn de succescriteria realistisch en haalbaar?</li>
                    <li>
                      Welke risico's zijn er verbonden aan het testen van deze
                      hypothese?
                    </li>
                    <li>
                      Hoe goed sluit deze hypothese aan bij de behoeften van de
                      doelgroep?
                    </li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Format:</h4>
                  <div className="space-y-2">
                    <p>
                      <strong>Gebruikersprobleem:</strong> [Observatie van
                      pijnpunt]
                    </p>
                    <p>
                      <strong>We denken dat:</strong> [Onderliggende
                      behoefte/oorzaak]
                    </p>
                    <p>
                      <strong>Dit testen we door:</strong> [Generieke
                      oplossingsrichting]
                    </p>
                    <p>
                      <strong>Succescriterium:</strong> [Meetcriterium zonder
                      technische details]
                    </p>
                  </div>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Voorbeeld:</h4>
                  <div className="space-y-2">
                    <p>
                      <strong>Gebruikersprobleem:</strong> "Studenten besteden 30+
                      minuten aan het vinden van relevante feesten"
                    </p>
                    <p>
                      <strong>We denken dat:</strong> Gebruikers behoefte hebben
                      aan betere filter- en zoekfunctionaliteit
                    </p>
                    <p>
                      <strong>Dit testen we door:</strong> Verschillende
                      zoekinterface concepten te verkennen
                    </p>
                    <p>
                      <strong>Succescriterium:</strong> 70% vindt binnen 5 minuten
                      3 relevante feesten
                    </p>
                  </div>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Adviseren"],
            },
          },
        ],
      },
      {
        key: "sprint",
        title: "🎨 Design Sprint",
        steps: [
          {
            title: "Prototype Personas",
            icon: "🧑",
            phase: "Stap 1: Map",
            example: "Maak gedetailleerde gebruikerprofielen",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Prototype Personas
                      </h1>
                      <p className="text-lg text-gray-700">
                        Creëer levensechte gebruikersprofielen die je doelgroep
                        perfect vertegenwoordigen. Deze personas helpen je team om
                        gebruikersgericht te ontwerpen en beslissingen te maken.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Een goede persona bevat:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Demografische informatie</li>
                          <li>Doelen en frustraties</li>
                          <li>Technologiegebruik</li>
                          <li>Gedragspatronen</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/prototype-persona.png"
                        alt="Prototype Persona voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Example Persona Card */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <div className="bg-white p-6 rounded-lg shadow-lg">
                    <div className="flex items-center gap-4 mb-8">
                      <div className="text-yellow-400 text-4xl">👥</div>
                      <h1 className="text-3xl font-bold">Student Persona</h1>
                    </div>
  
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                      {/* Left column with avatar and basic info */}
                      <div className="md:col-span-1 space-y-6">
                        <div className="w-full aspect-square rounded-lg overflow-hidden bg-gray-100">
                          <svg
                            viewBox="0 0 100 100"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="50" cy="50" r="48" fill="#FFE5D9" />
                            <path
                              d="M25 45C25 25 40 20 50 20C60 20 75 25 75 45V60C75 60 65 65 50 65C35 65 25 60 25 60V45Z"
                              fill="#4A90E2"
                            />
                            <circle cx="50" cy="45" r="25" fill="#FFE0BD" />
                            <path
                              d="M40 45C40 45 45 50 50 50C55 50 60 45 60 45"
                              stroke="#424242"
                              fill="none"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                            <circle cx="42" cy="40" r="2" fill="#424242" />
                            <circle cx="58" cy="40" r="2" fill="#424242" />
                            <path
                              d="M25 75C25 65 35 60 50 60C65 60 75 65 75 75V100H25V75Z"
                              fill="#2C5282"
                            />
                          </svg>
                        </div>
  
                        <div className="space-y-2">
                          <p>
                            <span className="font-bold">Naam:</span> Lisa
                          </p>
                          <p>
                            <span className="font-bold">Leeftijd:</span> 21 jaar
                          </p>
                          <p>
                            <span className="font-bold">Studie:</span>{" "}
                            Communicatie
                          </p>
                          <p>
                            <span className="font-bold">Jaar:</span> 2e jaars
                          </p>
                        </div>
                      </div>
  
                      {/* Right section with grid of info boxes */}
                      <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-gray-100 p-4 rounded-lg">
                          <h3 className="font-bold text-lg mb-2 bg-black text-yellow-400 inline-block px-2">
                            Profiel
                          </h3>
                          <p>
                            Actief lid van studievereniging, organiseert
                            regelmatig feesten en borrels. Sociaal en heeft een
                            groot netwerk, maar raakt gefrustreerd door de chaos
                            in planning.
                          </p>
                        </div>
  
                        <div className="bg-gray-100 p-4 rounded-lg">
                          <h3 className="font-bold text-lg mb-2 bg-black text-yellow-400 inline-block px-2">
                            Uitdaging
                          </h3>
                          <p>
                            Efficiënt organiseren van feesten zonder stress en
                            miscommunicatie door verspreide informatie.
                          </p>
                        </div>
  
                        <div className="bg-gray-100 p-4 rounded-lg">
                          <h3 className="font-bold text-lg mb-2 bg-black text-yellow-400 inline-block px-2">
                            Gedrag & Gewoontes
                          </h3>
                          <ul className="list-disc ml-4">
                            <li>Gebruikt WhatsApp voor alle communicatie</li>
                            <li>Deelt evenementen via Instagram Stories</li>
                            <li>Plant afspraken in Google Calendar</li>
                            <li>Beheert taken via losse notities</li>
                          </ul>
                        </div>
  
                        <div className="bg-gray-100 p-4 rounded-lg">
                          <h3 className="font-bold text-lg mb-2 bg-black text-yellow-400 inline-block px-2">
                            Pijnpunten
                          </h3>
                          <ul className="list-disc ml-4">
                            <li>Informatie raakt verspreid over apps</li>
                            <li>Moeilijk overzicht te houden</li>
                            <li>Belangrijke details raken verloren in chats</li>
                            <li>Veel tijd kwijt aan coördinatie</li>
                          </ul>
                        </div>
  
                        <div className="bg-gray-100 p-4 rounded-lg">
                          <h3 className="font-bold text-lg mb-2 bg-black text-yellow-400 inline-block px-2">
                            Verwachtingen
                          </h3>
                          <ul className="list-disc ml-4">
                            <li>Eenvoudig taken kunnen verdelen</li>
                            <li>Snel kunnen zien wie wat doet</li>
                            <li>Makkelijk updates kunnen delen</li>
                            <li>Alles op één plek kunnen vinden</li>
                          </ul>
                        </div>
  
                        <div className="bg-gray-100 p-4 rounded-lg">
                          <h3 className="font-bold text-lg mb-2 bg-black text-yellow-400 inline-block px-2">
                            Doelen
                          </h3>
                          <ul className="list-disc ml-4">
                            <li>Minder tijd kwijt aan organisatie</li>
                            <li>Betere communicatie met team</li>
                            <li>Succesvollere evenementen</li>
                            <li>Meer plezier in het organiseren</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Onderzoek & Data</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Check projectbeschrijving</li>
                      <li>Bekijk stakeholder input</li>
                      <li>Onderzoek doelgroep online</li>
                      <li>Gebruik bestaande data</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Persona Ontwikkeling</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Schets basis profiel</li>
                      <li>Voeg context toe</li>
                      <li>Beschrijf gedragspatronen</li>
                      <li>Definieer pijnpunten</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Validatie</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Check met stakeholders</li>
                      <li>Verfijn details</li>
                      <li>Maak visueel aantrekkelijk</li>
                      <li>Deel met team</li>
                    </ul>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    2-3 hours
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor effectieve persona's",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">
                    Tips voor effectieve persona's:
                  </h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Baseer op echte interviews (als mogelijk)</li>
                    <li>Focus op gedrag ipv demografie</li>
                    <li>Maak maximaal 3 persona's</li>
                    <li>Gebruik foto's voor levendigheid</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Gebruik 'Jobs to be Done' framework voor diepere inzichten
                    </li>
                    <li>
                      Creëer anti-persona's om te verduidelijken voor wie je niet
                      ontwerpt
                    </li>
                    <li>Update persona's regelmatig met nieuwe inzichten</li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/persona-types/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Complete Guide to Personas (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.uxbooth.com/articles/creating-personas/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Creating User Personas (UX Booth)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Zijn de personas gebaseerd op echte gebruikersdata?</li>
                    <li>Beschrijven de personas zowel gedrag als motivatie?</li>
                    <li>
                      Hoe representatief zijn de personas voor je doelgroep?
                    </li>
                    <li>Zijn de pijnpunten van de personas realistisch?</li>
                    <li>Helpen de personas bij het maken van ontwerpkeuzes?</li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Voorbeeld persona:</h4>
                  <p className="italic">
                    "Emma, 2e-jaars HBO studente Communicatie. Wil snel feesten
                    kunnen vinden maar vindt huidige apps te onoverzichtelijk.
                    Gebruikt vooral Instagram en WhatsApp."
                  </p>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Analyseren"],
            },
          },
          {
            title: "Journey Map",
            icon: "🗺️",
            phase: "Stap 1: Map",
            example: "Breng kritieke gebruikersmomenten in kaart",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Journey Mapping
                      </h1>
                      <p className="text-lg text-gray-700">
                        Visualiseer de volledige gebruikersreis om pijnpunten en
                        kansen te identificeren. Deze methode helpt je team om
                        vanuit het perspectief van de gebruiker te kijken en
                        verbeterpunten te ontdekken.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Essentiële elementen:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Start- en eindpunt</li>
                          <li>Gebruikersacties</li>
                          <li>Emotionele states</li>
                          <li>Pijnpunten & kansen</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/journey-map-example.jpg"
                        alt="Journey Map voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Large Example Image Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <h2 className="text-3xl font-bold text-gray-800 mb-6">
                    Journey Mapping Voorbeeld
                  </h2>
                  <img
                    src="/content/nl/design-sprint-hu/images/customer-journey-map.png"
                    alt="Journey Map voorbeeld"
                    className="rounded-lg shadow-lg w-full"
                  />
                </div>
  
                {/* Mapping Process */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Bepaal de Scope</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Identificeer startpunt</li>
                      <li>Definieer eindresultaat</li>
                      <li>Bepaal tijdsperiode</li>
                      <li>Kies gebruikersperspectief</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Breng Stappen in Kaart</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Noteer elke interactie</li>
                      <li>Gebruik één post-it per stap</li>
                      <li>Wees specifiek</li>
                      <li>Focus op acties</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Identificeer Emoties</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Markeer emotionele states</li>
                      <li>Noteer frustraties</li>
                      <li>Highlight succesmomenten</li>
                      <li>Zoek verbeterkansen</li>
                    </ul>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    2-3 hours
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor journey mapping",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Tips voor journey mapping:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Begin met as-is scenario</li>
                    <li>Gebruik kleurcodes voor emoties</li>
                    <li>Focus op kritieke momenten</li>
                    <li>Combineer met persona's</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Gebruik 'Service Blueprints' voor een dieper begrip van
                      backend processen
                    </li>
                    <li>
                      Implementeer 'Moment Mapping' voor cruciale interactiepunten
                    </li>
                    <li>
                      Voeg kwantitatieve data toe aan je journey map voor extra
                      inzicht
                    </li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/customer-journey-mapping/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Customer Journey Mapping Guide (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.interaction-design.org/literature/article/customer-journey-maps-walking-a-mile-in-your-customer-s-shoes"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Understanding Journey Maps (IDF)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Zijn alle belangrijke touchpoints geïdentificeerd?</li>
                    <li>Heb je emoties en pijnpunten per stap beschreven?</li>
                    <li>Is de journey map gevalideerd met echte gebruikers?</li>
                    <li>Zijn er alternatieve paden in kaart gebracht?</li>
                    <li>
                      Welke stappen in de journey zijn het meest problematisch?
                    </li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Voorbeeld journey:</h4>
                  <p className="italic">
                    "1. Feest zoeken → 2. Details checken → 3. Vrienden uitnodigen
                    → 4. Naar feest gaan → 5. Ervaring delen"
                  </p>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Analyseren", "Adviseren"],
            },
          },
  
          // Sketch Phase
          {
            title: "Crazy 8's",
            icon: "✏️",
            phase: "Stap 2: Sketch",
            example: "Genereer 8 ideeën in 8 minuten",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Crazy 8's Brainstorming
                      </h1>
                      <p className="text-lg text-gray-700">
                        Een krachtige methode om in slechts 8 minuten 8
                        verschillende ideeën te genereren. Perfect voor snelle
                        ideatie en het doorbreken van creatieve blokkades.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Ideaal voor:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Brainstormsessies</li>
                          <li>Design sprints</li>
                          <li>Probleemoplossing</li>
                          <li>Innovatie workshops</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/crazy8.png"
                        alt="Crazy 8's voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Step-by-Step Instructions */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg col-span-2">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Voorbereiding</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>
                        Vouw een A4 papier drie keer dubbel om 8 vakjes te maken
                      </li>
                      <li>Zorg voor een timer (telefoon of stopwatch)</li>
                      <li>Pak een pen of marker</li>
                      <li>Denk aan je hypothese of ontwerpvraag</li>
                    </ul>
                    <img
                      src="/content/nl/design-sprint-hu/images/fold.png"
                      alt="Vouwinstructies"
                      className="w-full rounded-lg mt-12"
                    />
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Timer Instellen</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Zet een timer op exact 1 minuut</li>
                      <li>Je krijgt 1 minuut per schets</li>
                      <li>Totale oefening duurt 8 minuten</li>
                      <li>Geen pauzes tussen schetsen</li>
                      <img
                        src="/content/nl/design-sprint-hu/images/timer.png"
                        alt="Herhalen"
                        className="w-40 rounded-lg mt-24"
                      />
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Schetsen</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Start met vakje 1, linksboven</li>
                      <li>Schets snel een idee (interface, flow, feature)</li>
                      <li>Gebruik de hele minuut</li>
                      <li>Focus op concept, niet op netheid</li>
                    </ul>
                    <img
                      src="/content/nl/design-sprint-hu/images/draw.png"
                      alt="Herhalen"
                      className="w-full rounded-lg mt-12"
                    />
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg col-span-2">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        4
                      </div>
                      <h3 className="font-bold">Herhalen</h3>
                    </div>
                    <div className="space-y-4">
                      <ul className="list-disc ml-4 space-y-2">
                        <li>
                          Als de timer afgaat, direct door naar het volgende vakje
                        </li>
                        <li>Reset de timer voor 1 nieuwe minuut</li>
                        <li>Schets een nieuw, ander idee</li>
                        <li>Herhaal tot alle 8 vakjes vol zijn</li>
                      </ul>
                      <div className="bg-amber-50 p-4 rounded-lg mt-4">
                        <p className="font-bold">⚡️ Belangrijk:</p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Blijf binnen de tijd - geen uitloop</li>
                          <li>Elk idee is goed - geen zelfcensuur</li>
                          <li>Varieer je ideeën - geen kleine aanpassingen</li>
                          <li>Gebruik alleen schetsen - minimale tekst</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Design Examples Section */}
                <div className="bg-white p-6 rounded-lg shadow-lg mt-8">
                  <h3 className="font-bold text-xl mb-4">
                    Voorbeeld Schetsen voor Feest App
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">1. Genre Filter</h4>
                      <p className="text-sm">
                        Visuele muziekgenre selectie met emoji's en kleuren
                        (🎸🎹🎉) voor snelle filtering
                      </p>
                    </div>
  
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">2. Kaartweergave</h4>
                      <p className="text-sm">
                        Interactieve map met feestlocaties en real-time
                        drukte-indicatoren
                      </p>
                    </div>
  
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">3. Groepschat+</h4>
                      <p className="text-sm">
                        Geïntegreerde chat met polls, takenlijst en gedeelde
                        uitgaven tracker
                      </p>
                    </div>
  
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">4. Smart Timeline</h4>
                      <p className="text-sm">
                        Tijdlijn view met AI-aanbevelingen gebaseerd op voorkeuren
                      </p>
                    </div>
  
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">5. Quick RSVP</h4>
                      <p className="text-sm">
                        One-tap aanmelding met automatische agenda-integratie
                      </p>
                    </div>
  
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">6. Budget Split</h4>
                      <p className="text-sm">
                        Automatische kostenverdeelcalculator met betaalverzoeken
                      </p>
                    </div>
  
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">7. Venue AR</h4>
                      <p className="text-sm">
                        AR preview van de locatie met looproutes en voorzieningen
                      </p>
                    </div>
  
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">8. Friend Finder</h4>
                      <p className="text-sm">
                        Live locatie-sharing met vrienden tijdens het feest
                      </p>
                    </div>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    8 mins
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor Crazy 8's",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Tips voor Crazy 8's:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Focus op kwantiteit boven kwaliteit</li>
                    <li>Combineer ideeën tijdens review</li>
                    <li>Gebruik dikke stiften</li>
                    <li>Geen woorden, alleen schetsen</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Start met een 'warm-up' oefening om creativiteit te
                      stimuleren
                    </li>
                    <li>
                      Gebruik 'constraint prompts' om out-of-the-box denken te
                      bevorderen
                    </li>
                    <li>
                      Implementeer een 'silent voting' ronde na het schetsen
                    </li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://designsprintkit.withgoogle.com/methodology/phase3-sketch/crazy-8s"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Crazy 8s Exercise (Google Ventures)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://uxplanet.org/generate-crazy-ideas-with-this-design-sprint-method-c6a36a16c3d5"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Step-by-Step Crazy 8s Guide (UX Planet)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.interaction-design.org/literature/article/learn-how-to-use-the-best-ideation-methods-brainstorming-braindumping-brainwriting-and-brainwalking"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Best Ideation Methods (IDF)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Zijn de ideeën voldoende divers?</li>
                    <li>Hoe innovatief zijn de oplossingen?</li>
                    <li>Sluiten de ideeën aan bij de gebruikersbehoefte?</li>
                    <li>Welke ideeën hebben de meeste potentie?</li>
                    <li>Zijn de ideeën technisch haalbaar?</li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-white p-4 rounded-lg shadow">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="p-2 text-left">Idee Type</th>
                        <th className="p-2 text-left">Voorbeeld Concepten</th>
                        <th className="p-2 text-left">HBO-i Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b">
                        <td className="p-2 align-top">UI Concept</td>
                        <td className="p-2 align-top">
                          <ul className="list-disc ml-4">
                            <li>Visuele muziekgenre filters</li>
                            <li>Live aanwezigheidsmeter</li>
                            <li>3D venue preview</li>
                          </ul>
                        </td>
                        <td className="p-2 align-top">Ontwerpen</td>
                      </tr>
                      <tr className="border-b">
                        <td className="p-2 align-top">Feature Concept</td>
                        <td className="p-2 align-top">
                          <ul className="list-disc ml-4">
                            <li>Groepsaanmelding met rolverdeling</li>
                            <li>Integratie met Spotify playlists</li>
                            <li>AI-gegenereerde dresscode suggesties</li>
                          </ul>
                        </td>
                        <td className="p-2 align-top">Realiseren</td>
                      </tr>
                      <tr>
                        <td className="p-2 align-top">Technical Concept</td>
                        <td className="p-2 align-top">
                          <ul className="list-disc ml-4">
                            <li>Real-time updates met WebSockets</li>
                            <li>Offline-first functionaliteit</li>
                            <li>Automated accessibility checks</li>
                          </ul>
                        </td>
                        <td className="p-2 align-top">Manage & Control</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Uitwerking Voorbeeld:</h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-white p-4 rounded-lg">
                      <h5 className="font-bold mb-2">Visueel Filter Concept</h5>
                      <p className="text-sm">
                        "Gebruikers kunnen genres selecteren via emoji-icons die
                        dynamisch aanpassen op basis van locatie en historie."
                      </p>
                      <div className="mt-2 text-xs text-blue-600">
                        Link naar HBO-i: Analyseren (user gedrag tracking)
                      </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg">
                      <h5 className="font-bold mb-2">
                        Technisch Proof-of-Concept
                      </h5>
                      <pre className="text-xs">
                        {`// WebSocket implementatie
          const socket = new WebSocket('wss://eventflow.live');
          socket.onmessage = (event) => {
            updateFeestStatus(JSON.parse(event.data));
          };`}
                      </pre>
                    </div>
                  </div>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Ontwerpen"],
            },
          },
  
          // Decide Phase
          {
            title: "Impact/Effort Matrix",
            icon: "📊",
            phase: "Stap 3: Decide",
            example: "Prioriteer ideeën op impact en moeite",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Impact/Effort Matrix
                      </h1>
                      <p className="text-lg text-gray-700">
                        Een strategische tool om ideeën te prioriteren op basis
                        van potentiële impact en benodigde inspanning. Perfect
                        voor het maken van datagedreven beslissingen over welke
                        features eerst te ontwikkelen.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Categorieën:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Quick Wins (Hoge Impact, Lage Effort)</li>
                          <li>Grote Projecten (Hoge Impact, Hoge Effort)</li>
                          <li>Vulwerk (Lage Impact, Lage Effort)</li>
                          <li>Moeras (Lage Impact, Hoge Effort)</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/impact-map.png"
                        alt="Impact/Effort Matrix voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Matrix Grid */}
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-green-100 p-6 rounded-lg">
                    <h3 className="font-bold text-lg mb-4">Quick Wins ⚡️</h3>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Push notificaties</li>
                      <li>Basis zoekfilters</li>
                      <li>Dark mode</li>
                    </ul>
                  </div>
  
                  <div className="bg-yellow-100 p-6 rounded-lg">
                    <h3 className="font-bold text-lg mb-4">Grote Projecten 🚀</h3>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>AI matching systeem</li>
                      <li>Betalingsintegratie</li>
                      <li>Real-time chat</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <h3 className="font-bold text-lg mb-4">Vulwerk 🔧</h3>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Extra thema's</li>
                      <li>Animaties</li>
                      <li>Social media icons</li>
                    </ul>
                  </div>
  
                  <div className="bg-red-100 p-6 rounded-lg">
                    <h3 className="font-bold text-lg mb-4">Moeras ⚠️</h3>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Blockchain integratie</li>
                      <li>VR experience</li>
                      <li>Custom CMS</li>
                    </ul>
                  </div>
                </div>
  
                {/* Scoring Guide */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">Scoring Guide</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="font-bold mb-2">Impact Score (1-10)</h4>
                      <ul className="list-disc ml-4 space-y-1">
                        <li>1-3: Minimale verbetering voor gebruikers</li>
                        <li>4-7: Merkbare verbetering in gebruikservaring</li>
                        <li>8-10: Game-changing feature voor product</li>
                      </ul>
                    </div>
                    <div>
                      <h4 className="font-bold mb-2">Effort Score (1-10)</h4>
                      <ul className="list-disc ml-4 space-y-1">
                        <li>1-3: Enkele dagen werk</li>
                        <li>4-7: 1-2 sprints</li>
                        <li>8-10: Meerdere sprints of complexe implementatie</li>
                      </ul>
                    </div>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    45 mins
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Tips voor prioritering",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Tips voor prioritering:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Betrek verschillende stakeholders</li>
                    <li>Gebruik stemstickers</li>
                    <li>Herzie na testing</li>
                    <li>Houd MVP focus</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Implementeer 'weighted scoring' systeem voor complexe
                      beslissingen
                    </li>
                    <li>
                      Gebruik 'What If' scenarios om flexibiliteit te testen
                    </li>
                    <li>Voeg een 'time to market' dimensie toe aan je matrix</li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.productplan.com/glossary/action-priority-matrix/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Impact/Effort Matrix Guide (ProductPlan)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/prioritization-matrices/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Using Priority Matrices (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.atlassian.com/agile/product-management/prioritization-framework"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Prioritization Methods (Atlassian)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Hoe heb je de impact van elke oplossing bepaald?
                      (Kwantitatieve data of kwalitatieve inschatting?)
                    </li>
                    <li>
                      Zijn er verborgen kosten/risico's bij de 'lage inspanning'
                      oplossingen?
                    </li>
                    <li>
                      Hoe sluit deze prioritering aan bij de HBO-i competenties
                      zoals Analyseren en Adviseren?
                    </li>
                    <li>
                      Heb je stakeholders betrokken bij het scoren van
                      impact/effort?
                    </li>
                    <li>Welke oplossing zou je testen als eerste?</li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-white p-4 rounded-lg shadow">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="p-2"></th>
                        <th className="p-2 text-center">Laag Effort</th>
                        <th className="p-2 text-center">Hoog Effort</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="p-2 bg-red-50 font-bold">Hoge Impact</td>
                        <td className="p-2 bg-green-50">
                          <div className="mb-2 font-bold">Quick Wins</div>
                          <ul className="list-disc ml-4">
                            <li>Push notificaties voor nieuwe feesten</li>
                            <li>Basis zoekfilters</li>
                            <li>RSVP functionaliteit</li>
                          </ul>
                        </td>
                        <td className="p-2 bg-yellow-50">
                          <div className="mb-2 font-bold">Grote Projecten</div>
                          <ul className="list-disc ml-4">
                            <li>AI matching algoritme</li>
                            <li>Real-time aanwezigheidstracking</li>
                            <li>Premium features systeem</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2 bg-blue-50 font-bold">Lage Impact</td>
                        <td className="p-2 bg-gray-100">
                          <div className="mb-2 font-bold">Vulwerk</div>
                          <ul className="list-disc ml-4">
                            <li>UI animaties</li>
                            <li>Achtergrondthema's</li>
                          </ul>
                        </td>
                        <td className="p-2 bg-purple-50">
                          <div className="mb-2 font-bold">Moeras</div>
                          <ul className="list-disc ml-4">
                            <li>NFT ticket systeem</li>
                            <li>VR feestervaring</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Prioriteringsmatrix Metrics</h4>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div className="bg-white p-3 rounded">
                      <div className="font-bold">Impact Score:</div>
                      <ul className="list-disc ml-4">
                        <li>1-3: Klein effect op UX</li>
                        <li>4-7: Merkbare verbetering</li>
                        <li>8-10: Game-changer</li>
                      </ul>
                    </div>
                    <div className="bg-white p-3 rounded">
                      <div className="font-bold">Effort Score:</div>
                      <ul className="list-disc ml-4">
                        <li>1-3: Minder dan 1 sprint</li>
                        <li>4-7: 1-2 sprints</li>
                        <li>8-10: 3+ sprints</li>
                      </ul>
                    </div>
                  </div>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Voorbeeld Feature Breakdown</h4>
                  <div className="grid grid-cols-3 gap-4 text-sm">
                    <div className="bg-white p-3 rounded">
                      <div className="font-bold mb-1">Push Notificaties</div>
                      <div className="text-xs">
                        Impact: 8/10
                        <br />
                        Effort: 2/10
                        <br />
                        HBO-i: Realiseren
                      </div>
                    </div>
                    <div className="bg-white p-3 rounded">
                      <div className="font-bold mb-1">AI Matching</div>
                      <div className="text-xs">
                        Impact: 9/10
                        <br />
                        Effort: 9/10
                        <br />
                        HBO-i: Analyseren
                      </div>
                    </div>
                    <div className="bg-white p-3 rounded">
                      <div className="font-bold mb-1">Premium Features</div>
                      <div className="text-xs">
                        Impact: 7/10
                        <br />
                        Effort: 6/10
                        <br />
                        HBO-i: Manage & Control
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Adviseren"],
            },
          },
  
          // Prototype Phase
          {
            title: "Storyboard & Prototype",
            icon: "🎨",
            phase: "Stap 4: Prototype",
            example: "Bouw klikbaar prototype",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Storyboard & Prototype
                      </h1>
                      <p className="text-lg text-gray-700">
                        Breng je ideeën tot leven door een visueel verhaal te
                        maken en dit om te zetten in een interactief prototype.
                        Deze fase helpt je om snel feedback te krijgen op je
                        ontwerp voordat je begint met ontwikkelen.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">Focus op:</p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Hoofdflow visualiseren</li>
                          <li>Interactiepatronen testen</li>
                          <li>Gebruikerservaring valideren</li>
                          <li>Technische haalbaarheid verkennen</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/storyboard.png"
                        alt="Storyboard voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Key Elements Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Storyboard Maken</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Schets key screens</li>
                      <li>Teken gebruikersflow</li>
                      <li>Markeer interactiemomenten</li>
                      <li>Noteer gebruikersemoties</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Prototype Bouwen</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Kies prototyping tool</li>
                      <li>Maak clickable flows</li>
                      <li>Voeg interacties toe</li>
                      <li>Test navigatie</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Validatie</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Check gebruikersflow</li>
                      <li>Test met teamleden</li>
                      <li>Verzamel feedback</li>
                      <li>Itereer ontwerp</li>
                    </ul>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    3-4 hours
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Prototyping tips",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Prototyping tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Gebruik bestaande UI kits</li>
                    <li>Test op mobiel formaat</li>
                    <li>Voeg micro-interacties toe</li>
                    <li>Houd versies bij</li>
                  </ul>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Implementeer 'Wizard of Oz' prototyping voor complexe
                      interacties
                    </li>
                    <li>
                      Gebruik 'component-based' prototyping voor efficiëntie en
                      consistentie
                    </li>
                    <li>
                      Integreer 'accessibility checks' in je prototyping proces
                    </li>
                  </ul>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/storyboards-visualize-ideas/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Storyboarding in UX Design (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.interaction-design.org/literature/article/prototyping-learn-eight-common-methods-and-best-practices"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Prototyping Methods Guide (IDF)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Waar in de user journey verwacht je de meeste verwarring?
                      (Test dit met de <strong>Huh? Test</strong>)
                    </li>
                    <li>
                      Hoe sluit het prototype aan bij je originele
                      hypothese-statement?
                    </li>
                    <li>
                      Welke <strong>niet-functionele requirements</strong> heb je
                      meegenomen? (Bijv. laadtijd, toegankelijkheid)
                    </li>
                    <li>
                      Heb je edge cases getest zoals foutmeldingen of lege states?
                    </li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="bg-red-50 p-4 rounded-lg">
                <h4 className="font-bold mb-2">Testscenario:</h4>
                <p className="italic">
                  "Student zoekt feest op datum → Bekijkt details → Deelt met
                  vrienden"
                </p>
              </div>
            ),
            hboi: {
              activities: ["Ontwerpen", "Realiseren"],
            },
          },
  
          // Test Phase
          {
            title: "Gebruikerstest",
            icon: "🧪",
            phase: "Stap 5: Test",
            example: "Test prototype met 5 gebruikers",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Gebruikerstest
                      </h1>
                      <p className="text-lg text-gray-700">
                        Test je prototype met echte gebruikers om je aannames te
                        valideren en verbeterpunten te identificeren. Deze
                        cruciale stap helpt je om te bepalen of je oplossing
                        daadwerkelijk het probleem oplost.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Essentiële elementen:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>5-7 testdeelnemers</li>
                          <li>Duidelijke testscenario's</li>
                          <li>Observatie en notities</li>
                          <li>Kwalitatieve feedback</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/design-sprint-test.jpg"
                        alt="Gebruikerstest voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Test Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Voorbereiding</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Testscript maken</li>
                      <li>Deelnemers werven</li>
                      <li>Prototype checken</li>
                      <li>Toestemmingsformulieren</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Uitvoering</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Think-aloud protocol</li>
                      <li>Observatie noteren</li>
                      <li>Tijden bijhouden</li>
                      <li>Doorvragen bij problemen</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Analyse</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Patronen identificeren</li>
                      <li>Pijnpunten verzamelen</li>
                      <li>Verbeteringen prioriteren</li>
                      <li>Rapport opstellen</li>
                    </ul>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    2-3 hours
                  </div>
                </div>
              </div>
            ),
            tipTitle: "Test tips",
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Test tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Gebruik think-aloud methode</li>
                    <li>Film de sessies</li>
                    <li>Houd scorelijst bij</li>
                    <li>Separate observer en moderator</li>
                  </ul>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Implementeer 'remote unmoderated testing' voor snelle
                      feedback
                    </li>
                    <li>
                      Gebruik 'task analysis' om specifieke interacties dieper te
                      testen
                    </li>
                    <li>
                      Voer 'comparative usability testing' uit met concurrerende
                      producten
                    </li>
                  </ul>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/usability-testing-101/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Usability Testing Guide (Nielsen Norman Group)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.usability.gov/how-to-and-tools/methods/usability-testing.html"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Complete Testing Guide (Usability.gov)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://maze.co/guides/usability-testing/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Modern Usability Testing Methods (Maze)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Hoe sluiten de testresultaten aan op je oorspronkelijke
                      Hypothesis Statement?
                    </li>
                    <li>
                      Welke inzichten bevestigen/weerleggen je oorspronkelijke
                      probleemstatement?
                    </li>
                    <li>
                      Welke aannames uit je Aannames Mapping zijn nu meer/minder
                      zeker geworden?
                    </li>
                    <li>
                      Bereikte je de vooraf gedefinieerde succescriteria uit je
                      hypothese?
                    </li>
                    <li>
                      Hoe ondersteunen deze inzichten de business-doelen uit je
                      <em> Aannames Verzamelen</em>?
                    </li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Testscript Flow:</h4>
                  <div className="grid grid-cols-3 gap-4 text-sm">
                    <div className="p-3 bg-white rounded-lg shadow">
                      <div className="font-bold mb-2">1. Voorbereiding</div>
                      <ul className="list-disc pl-3">
                        <li>Testplan klaar</li>
                        <li>Opnameapparatuur check</li>
                        <li>Consentformulier</li>
                      </ul>
                    </div>
  
                    <div className="p-3 bg-white rounded-lg shadow">
                      <div className="font-bold mb-2">2. Scenario's</div>
                      <ul className="list-disc pl-3">
                        <li>"Zoek een feest over 2 weken"</li>
                        <li>"Deel details met 3 vrienden"</li>
                        <li>"Annuleer een aanmelding"</li>
                      </ul>
                    </div>
  
                    <div className="p-3 bg-white rounded-lg shadow">
                      <div className="font-bold mb-2">3. Metingen</div>
                      <ul className="list-disc pl-3">
                        <li>Tijd per taak</li>
                        <li>Foutpercentage</li>
                        <li>SUS-score</li>
                      </ul>
                    </div>
                  </div>
                </div>
  
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Testresultaten:</h4>
                  <ul className="list-disc ml-4">
                    <li>
                      4/5 gebruikers vonden de zoekfunctie intuïtief en konden
                      binnen 30 seconden een feest vinden
                    </li>
                    <li>
                      3/5 gebruikers hadden moeite met het begrijpen van de
                      premium features, vooral het verschil tussen 'Spotlight' en
                      'Boost'
                    </li>
                    <li>
                      Alle gebruikers gaven aan behoefte te hebben aan
                      kalenderintegratie met hun bestaande agenda-apps
                    </li>
                    <li>
                      2/5 gebruikers probeerden tevergeefs een groepsaanmelding te
                      doen, wat niet mogelijk was in het huidige prototype
                    </li>
                    <li>
                      De filterfunctie voor muziekgenre werd als zeer waardevol
                      ervaren, met een gemiddelde tevredenheidsscore van 4.5/5
                    </li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Gebruikerscitaten:</h4>
                  <ul className="list-disc ml-4 italic">
                    <li>
                      "Wow, ik kan eindelijk feesten vinden die bij mijn
                      muzieksmaak passen!" - Emma, 21
                    </li>
                    <li>
                      "Ik snap niet echt wat ik krijg als ik voor premium ga. Kan
                      dat duidelijker?" - Daan, 19
                    </li>
                    <li>
                      "Het zou geweldig zijn als dit automatisch in mijn Google
                      Agenda komt." - Lisa, 23
                    </li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">
                    Actiepunten voor volgende iteratie:
                  </h4>
                  <ol className="list-decimal ml-4">
                    <li>
                      Herontwerp de uitleg van premium features met concrete
                      voorbeelden
                    </li>
                    <li>
                      Implementeer basis kalenderintegratie met populaire
                      agenda-apps
                    </li>
                    <li>Voeg functionaliteit toe voor groepsaanmeldingen</li>
                    <li>
                      Optimaliseer de zoekfunctie verder voor de 20% die moeite
                      had
                    </li>
                  </ol>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Bronnen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.nngroup.com/articles/usability-testing-101/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        NN/g Usability Testing Guide
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://pipdecks.com/workshop-tactics"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Workshop Tactics Testing Kit
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Realiseren"],
            },
          },
        ],
      },
      {
        key: "afronding",
        title: "🎯 Afronding",
        steps: [
          {
            title: "Productvisie",
            icon: "🌠",
            phase: "Stap 1",
            example: "Definieer lange-termijn doel",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Productvisie
                      </h1>
                      <p className="text-lg text-gray-700">
                        Formuleer een inspirerende visie die richting geeft aan je
                        product ontwikkeling. Een sterke visie helpt je team om
                        gefocust te blijven en de juiste beslissingen te maken.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Een goede visie bevat:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Duidelijke doelgroep</li>
                          <li>Concrete behoefte</li>
                          <li>Unieke waardepropositie</li>
                          <li>Onderscheidend vermogen</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/vision.png"
                        alt="Product Vision voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Analyse</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Identificeer doelgroep</li>
                      <li>Onderzoek behoeftes</li>
                      <li>Review concurrentie</li>
                      <li>Bepaal marktpositie</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Formulering</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Gebruik visie template</li>
                      <li>Focus op waarde</li>
                      <li>Wees specifiek</li>
                      <li>Blijf realistisch</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Validatie</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Check met stakeholders</li>
                      <li>Test op haalbaarheid</li>
                      <li>Verifieer onderscheid</li>
                      <li>Bevestig relevantie</li>
                    </ul>
                  </div>
                </div>
  
                {/* Vision Template */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">Visie Template</h3>
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <p className="italic">
                      "Voor [doelgroep] die [behoefte], is [product] een
                      [categorie] die [belofte]. Anders dan [concurrentie], doen
                      wij [onderscheidend vermogen]."
                    </p>
                  </div>
                  <div className="mt-4 bg-green-50 p-4 rounded-lg">
                    <h4 className="font-bold mb-2">Voorbeeld:</h4>
                    <p className="italic">
                      "Voor HBO-studenten die sociale activiteiten willen
                      organiseren, is EventFlow het platform dat alle planning
                      centraliseert. Anders dan WhatsApp groepen, bieden wij
                      geïntegreerde tools voor planning, betalingen en
                      aanwezigheidsregistratie."
                    </p>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    45 mins
                  </div>
                </div>
              </div>
            ),
            tips: (
              <div className="space-y-4">
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Gebruik de 'Future Backwards' techniek uit Innovation
                      Tactics PDF
                    </li>
                    <li>Koppel aan HBO-i competenties via meetbare leerdoelen</li>
                    <li>
                      Implementeer OKRs (Objectives & Key Results) voor tracking
                    </li>
                  </ul>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.productplan.com/learn/product-vision/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Creating Product Vision (ProductPlan)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.romanpichler.com/blog/tips-for-writing-compelling-product-vision/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Writing Compelling Vision (Roman Pichler)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Is de visie inspirerend en ambitieus genoeg?</li>
                    <li>Sluit de visie aan bij de gebruikersbehoefte?</li>
                    <li>Is het onderscheidend vermogen duidelijk?</li>
                    <li>Kan het team zich vinden in deze visie?</li>
                    <li>Is de visie realistisch en haalbaar?</li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Voorbeeld volgens template:</h4>
                  <p className="italic">
                    "Voor HBO-studenten die sociale activiteiten willen
                    organiseren,
                    <br />
                    is EventFlow het platform dat alle planning centraliseert.
                    <br />
                    Anders dan WhatsApp groepen, bieden wij geïntegreerde tools
                    voor
                    <br />
                    planning, betalingen en aanwezigheidsregistratie."
                  </p>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Adviseren"],
            },
          },
          {
            title: "User Story Mapping",
            icon: "🗺️",
            phase: "Stap 2",
            example: "Breng features in kaart voor MVP",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        User Story Mapping
                      </h1>
                      <p className="text-lg text-gray-700">
                        Visualiseer de ideale gebruikersreis met concrete features
                        en functionaliteiten. Anders dan journey mapping, focus je
                        hier op de oplossing: wat moet je systeem kunnen om de
                        gebruiker optimaal te ondersteunen?
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Een goed story map bevat:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Epics (hoofdfunctionaliteiten)</li>
                          <li>Features (specifieke mogelijkheden)</li>
                          <li>User Stories (concrete taken)</li>
                          <li>MVP afbakening</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/epic.png"
                        alt="Story Map voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Backbone Creëren</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Identificeer hoofdactiviteiten</li>
                      <li>Bepaal logische volgorde</li>
                      <li>Focus op gebruikersdoelen</li>
                      <li>Denk aan de hele flow</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Details Toevoegen</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Break down in features</li>
                      <li>Schrijf user stories</li>
                      <li>Voeg acceptatiecriteria toe</li>
                      <li>Bepaal afhankelijkheden</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">MVP Bepalen</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Prioriteer stories</li>
                      <li>Trek MVP lijn</li>
                      <li>Plan releases</li>
                      <li>Valideer met stakeholders</li>
                    </ul>
                  </div>
                </div>
  
                {/* Example Map */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">
                    Voorbeeld Story Map: Feest Organiseren
                  </h3>
                  <div className="space-y-6">
                    <div className="grid grid-cols-4 gap-4">
                      <div className="bg-blue-100 p-4 rounded-lg">
                        <h4 className="font-bold">Feest Zoeken</h4>
                        <div className="mt-2 space-y-2">
                          <div className="bg-white p-2 rounded">
                            Locatiefilter
                          </div>
                          <div className="bg-white p-2 rounded">Datumkiezer</div>
                          <div className="bg-white p-2 rounded">Genre filter</div>
                        </div>
                      </div>
                      <div className="bg-blue-100 p-4 rounded-lg">
                        <h4 className="font-bold">Aanmelden</h4>
                        <div className="mt-2 space-y-2">
                          <div className="bg-white p-2 rounded">Ticket kopen</div>
                          <div className="bg-white p-2 rounded">
                            Groepskorting
                          </div>
                          <div className="bg-white p-2 rounded">QR code</div>
                        </div>
                      </div>
                      <div className="bg-blue-100 p-4 rounded-lg">
                        <h4 className="font-bold">Voorbereiden</h4>
                        <div className="mt-2 space-y-2">
                          <div className="bg-white p-2 rounded">
                            Route plannen
                          </div>
                          <div className="bg-white p-2 rounded">
                            Dresscode check
                          </div>
                          <div className="bg-white p-2 rounded">
                            Vrienden uitnodigen
                          </div>
                        </div>
                      </div>
                      <div className="bg-blue-100 p-4 rounded-lg">
                        <h4 className="font-bold">Ervaring Delen</h4>
                        <div className="mt-2 space-y-2">
                          <div className="bg-white p-2 rounded">
                            Foto's uploaden
                          </div>
                          <div className="bg-white p-2 rounded">
                            Review schrijven
                          </div>
                          <div className="bg-white p-2 rounded">
                            Highlights delen
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    2-3 hours
                  </div>
                </div>
              </div>
            ),
            tips: (
              <div className="space-y-4">
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Begin met 'Walking Skeleton' (Pip Decks Workshop Tactics)
                    </li>
                    <li>Gebruik kleurcodes voor prioriteiten</li>
                    <li>Combineer met Impact/Effort Matrix</li>
                  </ul>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://jpattonassociates.com/story-mapping/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        User Story Mapping Guide (Jeff Patton)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://community.atlassian.com/t5/App-Central-articles/Understanding-Structure-of-the-User-Story-Map/ba-p/2863853"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Understanding Structure of the User Story Map (Atlassian)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.productplan.com/videos/story-mapping/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Story Mapping Tutorial (ProductPlan)
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Zijn de user stories INVEST (Independent, Negotiable,
                      Valuable, Estimable, Small, Testable)?
                    </li>
                    <li>Is de MVP scope duidelijk afgebakend?</li>
                    <li>
                      Zijn de afhankelijkheden tussen stories in kaart gebracht?
                    </li>
                    <li>Sluiten de stories aan bij de productvisie?</li>
                    <li>Zijn de acceptatiecriteria meetbaar?</li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-white p-4 rounded-lg shadow">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="p-2 text-left">Epic</th>
                        <th className="p-2 text-left">Feature</th>
                        <th className="p-2 text-left">User Stories (Sprint 1)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b">
                        <td className="p-2 align-top">Feest Discovery</td>
                        <td className="p-2 align-top">
                          <ul className="list-disc ml-4">
                            <li>Zoekfunctionaliteit</li>
                            <li>Filteropties</li>
                          </ul>
                        </td>
                        <td className="p-2 align-top">
                          <ul className="list-disc ml-4">
                            <li>Als student wil ik kunnen filteren op locatie</li>
                            <li>
                              Als bezoeker wil ik kunnen zoeken op trefwoord
                            </li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2 align-top">Aanmelding</td>
                        <td className="p-2 align-top">
                          <ul className="list-disc ml-4">
                            <li>Groeplidmaatschap</li>
                            <li>Betaalintegratie</li>
                          </ul>
                        </td>
                        <td className="p-2 align-top">
                          <ul className="list-disc ml-4">
                            <li>
                              Als organisator wil ik groepsaanmeldingen mogelijk
                              maken
                            </li>
                            <li>Als gebruiker wil ik via iDEAL kunnen betalen</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">
                    Research Stories (HBO-i Niveau 2):
                  </h4>
                  <ul className="list-disc ml-4">
                    <li>
                      "Onderzoek naar meest effectieve authenticatiemethode"
                    </li>
                    <li>"Analyse gebruikerstevredenheid na prototype testing"</li>
                  </ul>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Analyseren", "Ontwerpen"],
            },
          },
          {
            title: "Backlog & Planning",
            icon: "📋",
            phase: "Stap 3",
            example: "Prioriteer user stories voor eerste sprint",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Backlog & Planning
                      </h1>
                      <p className="text-lg text-gray-700">
                        Structureer en prioriteer alle projecttaken in een
                        overzichtelijke backlog. Een goed opgezette backlog helpt
                        je team om georganiseerd te blijven en de juiste focus te
                        houden tijdens de sprints.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Een complete backlog bevat:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Epics & Features</li>
                          <li>User Stories</li>
                          <li>Acceptatiecriteria</li>
                          <li>Story Points</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/backlog.png"
                        alt="Backlog voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Backlog Setup</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Kies project management tool</li>
                      <li>Definieer workflow states</li>
                      <li>Stel team rollen in</li>
                      <li>Maak backlog structuur</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">Story Writing</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Schrijf user stories</li>
                      <li>Definieer acceptatiecriteria</li>
                      <li>Voeg story points toe</li>
                      <li>Link aan epics/features</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Sprint Planning</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Prioriteer stories</li>
                      <li>Bepaal team capacity</li>
                      <li>Plan eerste sprint</li>
                      <li>Verdeel taken</li>
                    </ul>
                  </div>
                </div>
  
                {/* Example Story Format */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">User Story Template</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">Story Format</h4>
                      <p className="italic">
                        Als [rol] wil ik [actie] zodat [doel]
                      </p>
                      <div className="mt-4">
                        <h5 className="font-bold">Acceptatiecriteria:</h5>
                        <ul className="list-disc ml-4">
                          <li>Gegeven [context]</li>
                          <li>Wanneer [trigger]</li>
                          <li>Dan [resultaat]</li>
                        </ul>
                      </div>
                    </div>
  
                    <div className="bg-green-50 p-4 rounded-lg">
                      <h4 className="font-bold mb-2">Voorbeeld Story</h4>
                      <p className="italic">
                        "Als student wil ik kunnen filteren op locatie zodat ik
                        relevante feesten in mijn stad vind"
                      </p>
                      <div className="mt-4">
                        <h5 className="font-bold">Acceptatiecriteria:</h5>
                        <ul className="list-disc ml-4">
                          <li>Gegeven dat ik op de zoekpagina ben</li>
                          <li>Wanneer ik een stad selecteer</li>
                          <li>Dan zie ik alleen feesten in die stad</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    4-6 hours
                  </div>
                </div>
              </div>
            ),
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Backlog tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Houd stories klein (max 3 dagen werk)</li>
                    <li>Gebruik INVEST criteria voor user stories</li>
                    <li>Plan 20% buffer voor onverwachte taken</li>
                    <li>Scheid features en bugs</li>
                  </ul>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Gebruik story mapping voor context (Pip Decks Workshop
                      Tactics)
                    </li>
                    <li>
                      Implementeer "Walking Skeleton" voor kernfunctionaliteit
                    </li>
                    <li>Houd capacity planning bij voor realistisch plannen</li>
                  </ul>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.mountaingoatsoftware.com/agile/scrum/scrum-tools/product-backlog"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Product Backlog Management (Mountain Goat)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.scrum.org/resources/blog/nine-things-do-your-sprint-planning"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Sprint Planning Tips (Scrum.org)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.atlassian.com/agile/scrum/backlogs"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Agile Backlog Best Practices
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      Zijn de user stories klein genoeg om binnen een sprint te
                      voltooien?
                    </li>
                    <li>Hebben alle stories duidelijke acceptatiecriteria?</li>
                    <li>
                      Zijn er afhankelijkheden tussen stories die we moeten
                      aanpakken?
                    </li>
                    <li>
                      Zitten er taken in de backlog die niet bijdragen aan het
                      MVP?
                    </li>
                    <li>
                      Hoe goed sluit de prioritering aan bij de projectdoelen?
                    </li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Voorbeeld User Story:</h4>
                  <p className="italic">
                    "Als student wil ik kunnen filteren op locatie zodat ik
                    relevante feesten in mijn stad vind"
                  </p>
                  <div className="mt-2 bg-white p-3 rounded">
                    <strong>Acceptatiecriteria:</strong>
                    <ul className="list-disc ml-4">
                      <li>5-50km radius instelling</li>
                      <li>Automatische locatiedetectie</li>
                      <li>Manuele postcode invoer</li>
                    </ul>
                  </div>
                </div>
  
                <div className="bg-blue-50 p-4 rounded-lg grid grid-cols-2 gap-4">
                  <div>
                    <strong className="block mb-2">Epic:</strong>
                    <p>"Feest Discovery Flow"</p>
                  </div>
                  <div>
                    <strong className="block mb-2">Feature:</strong>
                    <p>"Geavanceerd zoeken en filteren"</p>
                  </div>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Manage & Control"],
            },
          },
          {
            title: "Documentatie",
            icon: "📚",
            phase: "Stap 4",
            example: "Maak onderhoudbare documentatie",
            description: (
              <div className="space-y-8">
                {/* Large Introduction Section */}
                <div className="bg-gradient-to-br from-purple-100 to-blue-100 p-8 rounded-xl shadow-lg">
                  <div className="flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2 space-y-4">
                      <h1 className="text-4xl font-bold text-gray-800">
                        Documentatie
                      </h1>
                      <p className="text-lg text-gray-700">
                        Leg zowel technische details als gebruikershandleidingen
                        vast voor je project. Goede documentatie zorgt voor
                        kennisdeling en maakt het project overdraagbaar.
                      </p>
                      <div className="bg-white bg-opacity-50 p-4 rounded-lg">
                        <p className="font-semibold text-gray-700">
                          Essentiële onderdelen:
                        </p>
                        <ul className="list-disc ml-4 mt-2">
                          <li>Technische architectuur</li>
                          <li>API documentatie</li>
                          <li>Gebruikershandleiding</li>
                          <li>Test documentatie</li>
                        </ul>
                      </div>
                    </div>
                    <div className="md:w-1/2">
                      <img
                        src="/content/nl/design-sprint-hu/images/documentation.png"
                        alt="Documentation voorbeeld"
                        className="rounded-lg shadow-md w-full"
                      />
                    </div>
                  </div>
                </div>
  
                {/* Process Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        1
                      </div>
                      <h3 className="font-bold">Technische Docs</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Architectuur diagram</li>
                      <li>API specificaties</li>
                      <li>Database schema</li>
                      <li>Deployment flow</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        2
                      </div>
                      <h3 className="font-bold">User Docs</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Getting started guide</li>
                      <li>Feature handleidingen</li>
                      <li>FAQ sectie</li>
                      <li>Troubleshooting</li>
                    </ul>
                  </div>
  
                  <div className="bg-gray-100 p-6 rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 font-bold">
                        3
                      </div>
                      <h3 className="font-bold">Test Docs</h3>
                    </div>
                    <ul className="list-disc ml-4 space-y-2">
                      <li>Test scenarios</li>
                      <li>Test resultaten</li>
                      <li>Bug rapportages</li>
                      <li>Performance tests</li>
                    </ul>
                  </div>
                </div>
  
                {/* Documentation Structure Example */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="font-bold text-xl mb-4">
                    Project Documentatie Structuur
                  </h3>
                  <div className="bg-gray-50 p-4 rounded-lg font-mono text-sm">
                    <pre className="whitespace-pre-wrap">
                      {`/docs
    /technical
      architecture.md
      api-reference.md
    /user
      getting-started.md
      faq.md
    /tests
      test-cases.md`}
                    </pre>
                  </div>
                  <div className="mt-6 bg-blue-50 p-4 rounded-lg">
                    <h4 className="font-bold mb-2">
                      API Documentatie Voorbeeld:
                    </h4>
                    <pre className="bg-white p-4 rounded-lg text-sm overflow-x-auto">
                      {`openapi: 3.0.0
  info:
    title: EventFlow API
    version: 1.0.0
  paths:
    /events:
      get:
        summary: Get events list
        parameters:
          - name: location
            in: query
            schema:
              type: string`}
                    </pre>
                  </div>
                </div>
  
                {/* Timer Badge */}
                <div className="flex justify-center mt-4">
                  <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-semibold">
                    4-6 hours
                  </div>
                </div>
              </div>
            ),
            tips: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Documentatie tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Houd het actueel met versiebeheer</li>
                    <li>Combineer tekst en schermafbeeldingen</li>
                    <li>Maak zoekbare documentatie</li>
                    <li>Scheid technisch en gebruikersdocs</li>
                  </ul>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🔑 Expert Tips:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Implementeer "docs as code" met Markdown</li>
                    <li>Automatiseer API docs met Swagger/OpenAPI</li>
                    <li>Maak video tutorials voor complexe flows</li>
                  </ul>
                </div>
  
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">📚 Leermiddelen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="https://www.writethedocs.org/guide/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        Write the Docs Guide
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://swagger.io/resources/articles/documenting-apis-with-swagger/"
                        className="text-blue-600 hover:underline"
                        target="_blank"
                      >
                        API Docs Best Practices
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">🤝 Feedbackvragen:</h4>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Is de documentatie volledig en up-to-date?</li>
                    <li>
                      Zijn alle technische details duidelijk beschreven voor
                      ontwikkelaars?
                    </li>
                    <li>
                      Is de gebruikershandleiding begrijpelijk voor
                      niet-technische gebruikers?
                    </li>
                    <li>
                      Welke onderdelen van de documentatie kunnen verder worden
                      verbeterd?
                    </li>
                    <li>
                      Zorgt deze documentatie ervoor dat anderen het project
                      eenvoudig kunnen overnemen?
                    </li>
                  </ul>
                </div>
              </div>
            ),
            examples: (
              <div className="space-y-4">
                <div className="bg-purple-50 p-4 rounded-lg">
                  <pre className="text-sm">
                    {`/docs
        /technical
          architecture.md
          api-reference.md
        /user
          getting-started.md
          faq.md
        /tests
          test-cases.md`}
                  </pre>
                </div>
  
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-bold mb-2">Swagger Voorbeeld:</h4>
                  <pre className="text-sm">
                    {`openapi: 3.0.0
      info:
        title: EventFlow API
        version: 1.0.0
      paths:
        /events:
          get:
            summary: Get events list
            parameters:
              - name: location
                in: query
                schema:
                  type: string`}
                  </pre>
                </div>
              </div>
            ),
            hboi: {
              activities: ["Analyseren", "Manage & Control"],
            },
          },
        ],
      },
    ];